module.exports = __webpack_public_path__ + "img/icon-arrow-right-alt.e155cbf8.svg";